export function setLanguageInUrl(ISO) {
  window.location.replace(
    window.location.pathname.slice(0, 4) +
      ISO +
      window.location.pathname.slice(6)
  );
}
